export default __webpack_public_path__ + "static/media/cfx-rightsizing.cae72877.png";